import clsx from 'clsx'
import React from 'react'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode | string

  isActive?: boolean

  isCancel?: boolean

  width?: number | string
}

export const Button: React.FC<ButtonProps> = ({
                                                children,
                                                icon,
                                                className,
                                                isActive = false,
                                                width = 168,
                                                isCancel,
                                                style,
                                                ...props
                                              }) => {
  return (
    <button
      className={clsx('btn', isActive && 'btn_isactive', className, isCancel && 'btn_iscancel')}
      style={{width, gap: 6, ...style}}
      {...props}
    >
      {children && <span>{children}</span>}
      {typeof icon === 'string' ? (
        <img src={icon} alt="" className="icon"/>
      ) : (
         icon
       )}
    </button>
  )
}